export const MIN_ZOOM = 2;
export const MAX_WORLD_ZOOM = 19;

export const DOCUMENT_TYPE = "mapy_lu";

export const ERROR = {
	NONE: 0,
	// obecna chyba
	ERROR: 1,
	EXT: 2,
	SIZE: 3,
	MAX_PHOTOS: 4,
	UPLOAD: 5,
};

export const SUBMIT_ERROR = "submit error";

// ctverec
export const IMG_SIZE = 70;

export const MAX_LENGTH = 2500;

export const ADD_FIRM_LINK = "https://admin.firmy.cz/pridat-firmu-zaciname?source=mapy";

export const SMALL_MEDIA_QUERY = "(max-width: 768px)";

export const MAX_PHOTOS = 20;

export const TEXTAREA_MIN_HEIGHT = 100;

export const TEXTAREA_3_LINES = 70;

export const TEXTAREA_5_LINES = 102;

export const EMAIL_REGEXP = /^[+-_!#$%&'*=?{|}~^/a-z0-9]+(\.[+-_!#$%&'*=?{|}~^/a-z0-9]+)*(\.*@seznam|\.*@email|\.*@post|\.*@spoluzaci|\.*@firmy|\.*@stream|@[a-z0-9-]+)(\.[a-z0-9-]+)*(\.[a-z-]{2,20})$/iu;

// nahrazeni na strane mantisu
export const SUMMARY_PREFIX = "{prefix}";

export const REPORT_ADJUSTMENT = "report-adjustment";

// eslint-disable-next-line no-constant-binary-expression
export const DEBUG = 0 && location.href.indexOf("mapy.c") === -1;
// eslint-disable-next-line no-constant-binary-expression
export const SCREENSHOT_DEBUG = 0 && location.href.indexOf("mapy.c") === -1;
